// removed by extract-text-webpack-plugin
module.exports = {"detailMain":"_2lVuMTfROlgkuDyQ5CiB9_","detailPrime":"_2mn35oQZ_me0mtozVgRsOG","detailHeaderPartner":"NODM5nKc2IuRooRnOmWfS","detailPartner":"_3m-LjDjkFpu5ZPv-HWlCUz"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/componentStyle/fieldBulletinBoard/FieldBulletinBoardDetail.scss
// module id = 568
// module chunks = 0